//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UsersSearch from './UsersSearch.vue'
import SuggestUserSection from './SuggestUserSection.vue'
import SuggestUserSelector from './SuggestUserSelector.vue'
export default {
  components: {
    UsersSearch,
    SuggestUserSection,
    SuggestUserSelector,
  },
  props: {
    users: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedUsers: [],
    }
  },
  computed: {
    searchedUsers() {
      return this.users.map((user) => ({
        ...user,
        name: `${user.names} ${user.lastnames}`,
        $isDisabled: !user.isSelectable,
      }))
    },
    suggestedUsers() {
      return this.users.filter((user) => user.isSelectable).slice(0, 10)
    },
  },
  methods: {
    selectedSearchedUsers(usersList) {
      this.selectedUsers = [...usersList]
      this.selectedUsers = this.selectedUsers.filter(
        (user, index, self) => index === self.findIndex((u) => u.id === user.id)
      )
      this.$emit('selected-users', this.selectedUsers)
    },
    selectedSuggestedUsers(usersList) {
      this.selectedUsers = [...usersList]
      this.selectedUsers = this.selectedUsers.filter(
        (user, index, self) => index === self.findIndex((u) => u.id === user.id)
      )
      this.$emit('selected-users', this.selectedUsers)
    },
  },
}
